enum TipoObservacao {
    VendaManipulacao = 0,
    OrdemManipulacao = 1,
    ConservacaoTransporte = 2,
    ExibirAvisoOrcamento = 3,
}

export default TipoObservacao;
